// eslint-disable-next-line no-restricted-imports
import { TickSize } from '@eih-netbroker/api-instrument';
import { atom } from 'jotai';

export type InstrumentTickSize = TickSize;

export type InstrumentTickSizeMap = Record<string, Array<InstrumentTickSize>>;

export const instrumentTickSizeAtom = atom<InstrumentTickSizeMap>({});
